document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('form[data-backorder-form]');

  if (!forms.length) return;

  forms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      handleBackorderForm(form);
    });
  });

});

function handleBackorderForm(form) {
  // Get variant id and title
  const variantId = document.querySelector('input[name="id"]').value;
  document.querySelector('input[name="variant_id"]').value = variantId;
  const formData = new FormData(form);

  fetch('http://stage.store-warnermusiccanada-com.nds.acquia-psi.com/d2c2025/record-backorder-request.php', {
    method: 'POST',
    body: formData,
    headers: {
      'Accept': 'application/json'
    }
  })
  .then(res => {
    if (!res.ok) throw new Error('Request failed');
    return res.json();
  })
  .then(data => {
    const returnTo = formData.get('return_to');
    window.location.href = returnTo;
  })
  .catch(err => {
    console.error(err);
  });
}